import ReferralNumberCombobox, {
    ReferralNumberOption,
} from 'flow/components/Setting/components/ReferralNumberCombobox';
import ReferralSoundCombobox, {
    SoundOption,
} from 'flow/components/Setting/components/ReferralSoundCombobox';
import SettingRow from 'flow/components/Setting/SettingRow';
import SettingSection from 'flow/components/Setting/SettingSection';
import Divider from 'flow/components/ui-components/Divider';
import RadioButton from 'flow/components/ui-components/RadioButton';
import Toggle from 'flow/components/ui-components/Toggle';
import useAppContext from 'flow/hooks/useAppContext';
import React from 'react';
import { CallsNotLetThroughValues } from '../CreateProfileModal';

interface Props {
    enableReferralSound: boolean;
    onToggleReferralSound: (newValue: boolean) => void;
    referralSound: SoundOption;
    onChangeReferralSound: (newValue: SoundOption) => void;
    referralNumber: ReferralNumberOption;
    onChangeReferralNumber: (newValue: ReferralNumberOption) => void;
    selected: CallsNotLetThroughValues;
    onChange: (newValue: CallsNotLetThroughValues) => void;
}

const ConnectCallsToSection = ({
    enableReferralSound,
    onToggleReferralSound,
    referralSound,
    onChangeReferralSound,
    referralNumber,
    onChangeReferralNumber,
    selected,
    onChange,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <>
            <Divider />

            <SettingSection>
                {i18next.t('settings.profile.wizard.callsnotletthrough')}
            </SettingSection>

            <SettingRow
                cta={
                    <Toggle
                        value={enableReferralSound}
                        onChange={() =>
                            onToggleReferralSound(!enableReferralSound)
                        }
                        text={i18next.t(
                            'settings.profile.wizard.callsnotletthrough.greeting',
                        )}
                    />
                }
            >
                {i18next.t(
                    'settings.profile.wizard.callsnotletthrough.greeting',
                )}
            </SettingRow>

            {enableReferralSound && (
                <ReferralSoundCombobox
                    ariaLabel={i18next.t(
                        'settings.profile.wizard.callsnotletthrough.greeting',
                    )}
                    className="mt-3"
                    sound={referralSound}
                    onChange={onChangeReferralSound}
                />
            )}

            <Divider />

            <SettingSection>
                {i18next.t('settings.profile.wizard.callsnotletthrough.after')}
            </SettingSection>

            <RadioButton
                name="callsNotLetThrough"
                checked={selected === 'voicemail'}
                onChange={() => onChange('voicemail')}
            >
                {i18next.t('settings.incoming_calls.profile.referal.voicemail')}
            </RadioButton>

            <RadioButton
                name="callsNotLetThrough"
                checked={selected === 'referral_number'}
                onChange={() => onChange('referral_number')}
            >
                {i18next.t(
                    'settings.profile.wizard.callsnotletthrough.forward',
                )}
            </RadioButton>

            {selected === 'referral_number' && (
                <div className="mt-2 mb-3">
                    <SettingSection className="text-sm/4">
                        {i18next.t(
                            'settings.incoming_calls.busy.number.navigation',
                        )}
                        <span>&nbsp;*</span>
                    </SettingSection>

                    <ReferralNumberCombobox
                        ariaLabel={i18next.t(
                            'settings.incoming_calls.busy.number.navigation',
                        )}
                        referralNumber={referralNumber}
                        onChange={onChangeReferralNumber}
                    />
                </div>
            )}

            <RadioButton
                name="callsNotLetThrough"
                checked={selected === 'hang_up'}
                onChange={() => onChange('hang_up')}
            >
                {i18next.t('settings.incoming_calls.profile.referal.hangup')}
            </RadioButton>

            {enableReferralSound && (
                <RadioButton
                    name="callsNotLetThrough"
                    checked={selected === 'repeat_sound'}
                    onChange={() => onChange('repeat_sound')}
                >
                    {i18next.t(
                        'settings.profile.wizard.callsnotletthrough.repeat',
                    )}
                </RadioButton>
            )}
        </>
    );
};

export default ConnectCallsToSection;
